import { Component, Input } from '@angular/core';
import { AuthorizationFacilityContactPAC, ServicingFacilityPAC } from '@shared/model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'servicing-facility-new-panel',
    templateUrl: './servicing-facility-new-panel.component.html',
    styleUrls: ['./servicing-facility-new-panel.component.scss'],
    standalone: false
})
export class ServicingFacilityNewPanelComponent {
  servicingFacilityNew: AuthorizationFacilityContactPAC;

 @Input() set servicingFacilityNewData(value: ServicingFacilityPAC) {
   this.servicingFacilityNew = value.facilityContact as AuthorizationFacilityContactPAC;
 }
}
